import React,{Component} from "react";

import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Tooltip,
  Badge,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Input,
  TabContent, TabPane, Nav, NavItem, NavLink,CardText
} from "reactstrap";
import { Redirect } from "react-router-dom";
import Switch from 'react-bootstrap-switch';
import ReadAloud from "components/Question/Speaking/ReadAloud.jsx";
import DescribeImage from "components/Question/Speaking/DescribeImage.jsx";
import RepeatSentece from "components/Question/Speaking/RepeatSentece.jsx";
import RetellLec from "components/Question/Speaking/RetellLec.jsx";
import ShortQue from "components/Question/Speaking/ShortQue.jsx";
import Summary from "components/Question/Writting/Summary.jsx";
import Essay from "components/Question/Writting/Essay.jsx";
import SingleAnswer from "components/Question/Reading/SingleAnswer.jsx";
import MultipleAnswer from "components/Question/Reading/MultipleAnswer.jsx";
import Reorder from "components/Question/Reading/Reorder.jsx";
import ReadingBlank from "components/Question/Reading/ReadingBlank.jsx";
import WrittingBlank from "components/Question/Reading/WrittingBlank.jsx";
import Summer from "components/Question/Listening/Summer.jsx";
import McqSingle from "components/Question/Listening/McqSingle.jsx";
import McqMulti from "components/Question/Listening/McqMulti.jsx";
import ListeningBlank from "components/Question/Listening/ListeningBlank.jsx";
import MissingWord from "components/Question/Listening/MissingWord.jsx";
import CorrectSummary from "components/Question/Listening/CorrectSummary.jsx";
import Dictation from "components/Question/Listening/Dictation.jsx";
import Highlight from "components/Question/Listening/Highlight.jsx";
import ShowHistory from "views/ShowHistory.jsx";
import ShowHistoryData from "views/ShowHistoryData.jsx";
import ChromeCheck from "views/ChromeCheck.jsx";
import QuestionComment from "views/QuestionComment.jsx";
import UserNotes from "views/UserNotes.jsx";
import {userContext} from 'userContext';
import ReactHtmlParser from 'react-html-parser';
import API,{base} from "api.js";
import {store} from 'store/index';
import { setAlert} from 'action/index.js';
import { setUser} from 'action/index.js';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactPlayer from 'react-player';

const mapStateToProps = (state) => {
   return {
      user: state.user
   };
};

const mapDispatchToProps = (dispatch) => {
   return {
      setUser: (user) => dispatch(setUser(user))
   };
};
class Practice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionData:[],
      currentQuestion:0, //parseInt(this.props.match.params.index),
      isRecording: false,
      blobURL: '',
      error:'',
      history:[],
      board:[],
      historyData:[],
      history_flag:false,
      isBlocked: false,
      is_answer:false,
      is_result:false,
      resultObj:{'text_answer':'','length':0,'type':this.props.match.params.id,'answer':'','script':'','q_ans':'','correct':''},
      resultData:'',
      process:false,
      testModal:false,
      textAr:false,
      comment_process:false,
      modal:false,
      switched:false,
      reportText:'',
      history_process:false,
      historyMore:false,
      boardMore:false,
      restart:false,
      type:this.props.match.params.id,
      prediction:this.props.match.params.type,
      aType:this.props.match.params.aType,
      mark:this.props.match.params.mark,
      atmptd:this.props.match.params.attempted,
      complexity:this.props.match.params.complexity,
      submitFlag:false,
      attempted:0,
      intervalId1:"",
      secondCount1:0,
      note_flag:false,
      board_process:false,
      all_ok: true,
      hideNav:false,
      user:store.getState().user,
      isSubscribed:(store.getState().user.active_subscription.length > 0)?true:false,
      viewVideo:false,
      viewHindiVideo:false,
      videoModal:false,
      videoModalState:false,
      videoHindiModal:false,
      videoHindiModalState:false,
      videoUrl:"",
      videoHindiUrl:"",
      attemptedQuestions:[],
      isAttempted:false,
    };

  }

  toggle = tab => {
    if(this.state.activeTab !== tab){
      this.setState({activeTab:tab});
    }
  }
  async componentDidMount() {
    let hideNav = false;
    let urlParams = new URLSearchParams(window.location.search);
      let myParam = urlParams.get('view');
      if (parseInt(myParam) === 1) {
        hideNav = true;
      }
      this.setState({hideNav:hideNav})
    API({
      method: 'GET',
      url: 'question/'+this.state.type+'?prediction='+this.state.prediction+'&type='+this.state.aType+'&mark='+this.state.mark+'&attempted='+this.state.atmptd+'&complexity='+this.state.complexity+'&practice='+!hideNav,
    }).then(data => {
      var intervalId1 = setInterval(this.timer1, 1000);
      var currentQuestion = 0;
      data.data.data.map((v,k) =>{ if (v.id == parseInt(this.props.match.params.index)) { currentQuestion=k; } });
      this.setState({'questionData':data.data.data,tag:(data.data.data[currentQuestion].tag.length >0)?data.data.data[currentQuestion].tag[0].tag:"grey",intervalId1:intervalId1,currentQuestion:currentQuestion,testCount:data.data.data[this.state.currentQuestion].tested.length});
      if (data.data.total != 0) {
        document.querySelector('.selectPage').value = currentQuestion;
      }
      var videourl = this.state.questionData[this.state.currentQuestion].video;
      if(videourl !== null){
        console.log(videourl)
        this.setState({videoUrl:videourl})
        this.setState({viewVideo:true})
      }
      var hindivideourl = this.state.questionData[this.state.currentQuestion].hindi_video;
      if(hindivideourl !== null){
        console.log(hindivideourl)
        this.setState({videoHindiUrl:hindivideourl})
        this.setState({viewHindiVideo:true})
      }
      API({
        method: 'GET',
        url: 'attempted_questions',
      }).then(data => {
        var attempted_questions = data.data.data.attempted_questions;
        const obj = JSON.parse(attempted_questions);
        var questions_id = obj.questions_id;
        this.setState({attemptedQuestions:questions_id})
        this.loadAttemptedQuestiondata(this.state.currentQuestion);
      }).catch(()=>{ 
      });
    }).catch(()=>{
      
    });
  }

  loadQuestiondata = () => {
    API({
      method: 'GET',
      url: 'question/',
    }).then(data => {
      this.setState({'questionData':data.data.data});
      
  }).catch(()=>{
      
    });
  }

  loadAttemptedQuestiondata = (currentQuestionId) => {
    var attemptedQuestions = this.state.attemptedQuestions;
    var question_id = this.state.questionData[currentQuestionId].id;
    var question_id = question_id.toString();
    var checkquestionid = attemptedQuestions.includes(question_id)
    console.log(currentQuestionId);
    console.log(attemptedQuestions);
    console.log(question_id);
    console.log(checkquestionid);
    if(checkquestionid){
      this.setState({isAttempted:true})
    }else{
      this.setState({isAttempted:false})
    }
  }

  componentWillUnmount = () => {
    clearInterval(this.state.intervalId1);
  }

  changeReportText = (e) => {
    let { name, value } = e.target;
    this.setState({ [name] : value });
  }

  submitReport = () => {
    if(this.state.comment === ""){
      store.dispatch(setAlert({'flag':true,'type':2,'message':"Message cant't be empty"}));
      return ""
    }

    var bodyFormData = new FormData();
    bodyFormData.set('text', this.state.reportText);
    bodyFormData.set('question_id', this.state.questionData[this.state.currentQuestion].id);
    API({
      method: 'POST',
      data: bodyFormData,
      url: 'report/question',
    }).then(data => {
      if (data.status === 200) {
        this.setState({'reportText':'',modal:false});
        store.dispatch(setAlert({'flag':true,'type':1,'message':data.data.message}));  
      }
      
    }).catch(()=>{
      
    });  
  }

  nextButton = () => {
    this.loadAttemptedQuestiondata(this.state.currentQuestion+1);
    console.log(this.state.currentQuestion)
    let checkifnexthasvideo = this.state.questionData[this.state.currentQuestion+1].video;
    let checkifnexthashindivideo = this.state.questionData[this.state.currentQuestion+1].hindi_video;
    document.querySelector('.selectPage').value = this.state.currentQuestion+1;
    this.setState({comment:[],board:[],history:[],process:false,currentQuestion:this.state.currentQuestion + 1,tag:(this.state.questionData[this.state.currentQuestion+1].tag.length > 0)?this.state.questionData[this.state.currentQuestion+1].tag[0].tag:"grey",is_answer:false,is_result:false,history_flag:false,comment_flag:false,secondCount1:0,testCount:this.state.questionData[this.state.currentQuestion+1].tested.length,board_flag:false,history_flag:false,comment_flag:false,note_flag:false,viewVideo:checkifnexthasvideo !== null ? true : false,viewHindiVideo:checkifnexthashindivideo !== null ? true : false,videoUrl:checkifnexthasvideo !== null ? checkifnexthasvideo : null,videoHindiUrl:checkifnexthashindivideo !== null ? checkifnexthashindivideo : null});
    this.forceUpdate();
    window.scrollTo(100, 100);
  }

  prevButton = () => {
    this.loadAttemptedQuestiondata(this.state.currentQuestion-1);
    let checkifprevhasvideo = this.state.questionData[this.state.currentQuestion-1].video;
    let checkifprevhashindivideo = this.state.questionData[this.state.currentQuestion-1].hindi_video;
    document.querySelector('.selectPage').value = this.state.currentQuestion-1;
    this.setState({comment:[],board:[],history:[],process:false,tag:(this.state.questionData[this.state.currentQuestion-1].tag.length >0)?this.state.questionData[this.state.currentQuestion-1].tag[0].tag:"grey",currentQuestion:this.state.currentQuestion - 1,is_answer:false,is_result:false,history_flag:false,comment_flag:false,secondCount1:0,testCount:this.state.questionData[this.state.currentQuestion-1].tested.length,board_flag:false,history_flag:false,comment_flag:false,note_flag:false,viewVideo:checkifprevhasvideo !== null ? true : false,videoUrl:checkifprevhasvideo !== null ? checkifprevhasvideo : null,viewHindiVideo:checkifprevhashindivideo !== null ? true : false,videoHindiUrl:checkifprevhashindivideo !== null ? checkifprevhashindivideo : null});
    this.forceUpdate();
    window.scrollTo(100, 100);
  }

  showModal = () =>{
    this.setState({modal:!this.state.modal});
  }

  submitResponse = (data,f = false) => {
    let qdata = this.state.questionData[this.state.currentQuestion];
    let obj = {
      data:data.data,
      text_answer:data.answer,
      length:data.length,
      type:qdata.subcategory_id,
      id:qdata.id,
      answer:qdata.question,
      script:qdata.audio_script,
      q_ans:qdata.answer,
      html:qdata.html,
      correct:data.correct,
      lang: data.lang,
      duration: data.duration,
      audio_text:data.audio_text 
    };
    this.setState({resultObj:obj,submitFlag:f});
  }

  changeSelectPagination = (e) => {
    let checkifSelectPaghasvideo = this.state.questionData[parseInt(e.target.value)].video;
    let checkifSelectPaghashindivideo = this.state.questionData[parseInt(e.target.value)].hindi_video;
    console.log(checkifSelectPaghasvideo)
    console.log(parseInt(e.target.value))
    this.loadAttemptedQuestiondata(e.target.value);
    this.setState({comment:[],board:[],history:[],process:false,currentQuestion:parseInt(e.target.value),tag:(this.state.questionData[parseInt(e.target.value)].tag.length > 0)?this.state.questionData[parseInt(e.target.value)].tag[0].tag:"grey",is_answer:false,is_result:false,history_flag:false,comment_flag:false,note_flag:false,secondCount1:0,viewVideo:checkifSelectPaghasvideo !== null ? true : false,videoUrl:checkifSelectPaghasvideo !== null ? checkifSelectPaghasvideo : null,viewHindiVideo:checkifSelectPaghashindivideo !== null ? true : false,videoHindiUrl:checkifSelectPaghashindivideo !== null ? checkifSelectPaghashindivideo : null});
    this.forceUpdate();
  }

  showResponse = () => {
    this.setState({is_answer:true,resultData:'',process:true}); 
    if([1,2,3,4,5].includes(this.state.questionData[this.state.currentQuestion].subcategory_id)){
      var bodyFormData = new FormData();
        bodyFormData.set('text', this.state.resultObj.answer);
        bodyFormData.set('text_answer', this.state.resultObj.text_answer);
        bodyFormData.set('answer', this.state.resultObj.ans);
        bodyFormData.set('q_ans', this.state.resultObj.q_ans);
        bodyFormData.set('length', this.state.resultObj.length);
        bodyFormData.set('file', this.state.resultObj.data);
        bodyFormData.set('duration', this.state.resultObj.duration);
        bodyFormData.set('type', this.state.resultObj.type);
        bodyFormData.set('script', this.state.resultObj.script);
        bodyFormData.set('id', this.state.resultObj.id);
        bodyFormData.set('lang', this.state.resultObj.lang);
        bodyFormData.set('practice', '1');
        bodyFormData.set('audio_text', this.state.resultObj.audio_text);
        API({
          method: 'POST',
          url: 'check/answer1',
          data:bodyFormData
        }).then(data => {
          if (data.data.user) {
            store.dispatch(setUser(data.data.user));  
          }
          if (this.state.questionData[this.state.currentQuestion].subcategory_id === 5) {
            this.setState({user:data.data.user,historyData:data.data.data.score_data,process:false,resultData:`Content Score : ${data.data.data.content} \n Your Response: ${data.data.data.transcript}` });
          }else{
            this.setState({user:data.data.user,historyData:data.data.data.score_data,process:false,resultData:`Content Score : ${data.data.data.content} \n Fluency Score : ${data.data.data.fluency} \n Pronunciation Score : ${data.data.data.pronunciation} \n ${data.data.data.html}` });
          }
              
      }).catch(()=>{
      
    });
    }else if([6,7].includes(this.state.questionData[this.state.currentQuestion].subcategory_id)){
      var bodyFormData = new FormData();
        bodyFormData.set('text', this.state.resultObj.answer);
        bodyFormData.set('text_answer', this.state.resultObj.text_answer);
        bodyFormData.set('type', this.state.resultObj.type);
        bodyFormData.set('answer', this.state.resultObj.q_ans);
        bodyFormData.set('script', this.state.resultObj.script);
        bodyFormData.set('length', this.state.resultObj.length);
        bodyFormData.set('id', this.state.resultObj.id);
        bodyFormData.set('practice', '1');
        bodyFormData.set('lang', this.state.resultObj.lang);
        API({
          method: 'POST',
          url: 'check/answer1',
          data:bodyFormData
        }).then(data => {
          if (data.data.user) {
            store.dispatch(setUser(data.data.user));  
          }
          if(this.state.questionData[this.state.currentQuestion].subcategory_id === 6){
            this.setState({user:data.data.user,process:false,historyData:data.data.data.score_data,resultData:`Content : ${data.data.data.content_score}/2 \n Form : ${data.data.data.form_score}/1 \n Grammar and spellings : ${data.data.data.grammar_score}/2 \n Vocabulary : ${data.data.data.vocab_score}/2 \n Total : ${data.data.data.total_s}/7 \n ${data.data.data.error}` });
          }else{
            this.setState({user:data.data.user,process:false,historyData:data.data.data.score_data,resultData:`Content : ${data.data.data.content_score}/3 \n Form : ${data.data.data.form_score}/2 \n Grammar : ${data.data.data.grammar_score}/2 \n Vocabulary : ${data.data.data.vocab_score}/2 \n Linguistic range
 : ${data.data.data.ling_score}/2 \n Structure : ${data.data.data.struct_score}/2 \n Spelling : ${data.data.data.spelling_score}/2 \n Total : ${data.data.data.total_s}/15 \n ${data.data.data.error}` });
          }
              
      }).catch(()=>{
      
    });
    }
    else if([8,9,10,11,12].includes(this.state.questionData[this.state.currentQuestion].subcategory_id)){
      var bodyFormData = new FormData();
      bodyFormData.set('text', this.state.resultObj.answer);
      bodyFormData.set('selected', this.state.resultObj.text_answer);
      bodyFormData.set('type', this.state.resultObj.type);
      bodyFormData.set('answer', this.state.resultObj.correct);
      bodyFormData.set('script', this.state.resultObj.script);
      bodyFormData.set('correct', this.state.resultObj.correct);
      bodyFormData.set('id', this.state.resultObj.id);
      bodyFormData.set('practice', '1');
      bodyFormData.set('lang', this.state.resultObj.lang);
        API({
          method: 'POST',
          url: 'check/answer1',
          data:bodyFormData
        }).then(data => {
            if (data.data.user) {
              store.dispatch(setUser(data.data.user));  
            }
            this.setState({user:data.data.user,process:false,historyData:data.data.data.score_data,resultData:`Score : ${data.data.data.score}/${data.data.data.from}` });
      }).catch(()=>{
      
    });
    }
    else if([13,14,15,17,19,20,18,16].includes(this.state.questionData[this.state.currentQuestion].subcategory_id)){
      
      var bodyFormData = new FormData();
        bodyFormData.set('text', this.state.resultObj.answer);
        bodyFormData.set('selected', this.state.resultObj.text_answer);
        bodyFormData.set('html', this.state.resultObj.html);
        bodyFormData.set('type', this.state.resultObj.type);
        bodyFormData.set('text_answer', this.state.resultObj.text_answer);
        bodyFormData.set('ans', this.state.resultObj.q_ans);
        bodyFormData.set('answer', this.state.resultObj.correct);
        bodyFormData.set('script', this.state.resultObj.script);
        bodyFormData.set('correct', this.state.resultObj.correct);
        bodyFormData.set('length', this.state.resultObj.length);
        bodyFormData.set('id', this.state.resultObj.id);
        bodyFormData.set('practice', '1');
        bodyFormData.set('lang', this.state.resultObj.lang);
        API({
          method: 'POST',
          url: 'check/answer1',
          data:bodyFormData
        }).then(data => {
          if (data.data.user) {
            store.dispatch(setUser(data.data.user));  
          }
          
          if(this.state.questionData[this.state.currentQuestion].subcategory_id === 13){
            this.setState({user:data.data.user,process:false,historyData:data.data.data.score_data,resultData:`Content : ${data.data.data.content_score}/2 \n Form : ${data.data.data.form_score}/2 \n Grammar : ${data.data.data.grammar_score}/2 \n Vocabulary : ${data.data.data.vocab_score}/2 \n Spelling : ${data.data.data.spelling_score}/2 \n Total : ${data.data.data.total_s}/10 \n ${data.data.data.error}` });
          }else if(this.state.questionData[this.state.currentQuestion].subcategory_id === 20){
            this.setState({user:data.data.user,process:false,historyData:data.data.data.score_data,resultData:`Score : ${data.data.data.score}/${data.data.data.from} \n ${data.data.data.html}` });
          }else{
            this.setState({user:data.data.user,process:false,historyData:data.data.data.score_data,resultData:`Score : ${data.data.data.score}/${data.data.data.from}` });
          }
      }).catch(()=>{
      
    });
    }
  }

  resultStatus = () => {
    this.setState({is_result:true});

  }
  showHistory = () => {
    this.setState({boardMore:false,history_flag:true,note_flag:false,comment_flag:false,board_flag:false,history_process:false});

  }

  showBoard = () => {
    this.setState({historyMore:false,note_flag:false,history_flag:false,board_flag:true,comment_flag:false,board_process:false});
  }

  showNotes = () => {
    this.setState({historyMore:false,history_flag:false,board_flag:false,note_flag:true,comment_flag:false,board_process:false});
  }

  showComment = () => {
    this.setState({comment_flag:true,history_flag:false,board_flag:false,note_flag:false,comment_process:false});
  }

  changeResponseArr = (data) => {
    this.setState({history:data});
  }

  testedFunc = () => {
    this.setState({testModal:true});    
  }
  toggleSwitch =(el,state) =>{
    this.setState({switched:(!this.state.switched)})
  }

  testedNo = () => {
      this.setState({testModal:false});    
  }

  testedYes = () => {
    var bodyFormData = new FormData();
    bodyFormData.set('question_id', this.state.questionData[this.state.currentQuestion].id);
      API({
          method: 'POST',
          url: 'tested/exam',
          data:bodyFormData
        }).then(data => {
            store.dispatch(setAlert({'flag':true,'type':1,'message':data.data.message}));
            this.setState({testModal:false, testCount:data.data.count});
      });
      this.setState({testModal:false});
      this.forceUpdate();    
  }

  timer1 = () => {
    this.setState({ secondCount1: this.state.secondCount1 +1 });
  }

  restartQuestion = () => {
    this.setState({restart:true,is_result:false,is_answer:false,secondCount1:0});
    this.forceUpdate();
  }

  showVideoModal = () => {
    this.setState({videoModal:true});
    this.setState({videoModalState:true});
    console.log(this.state);
  }

  showHindiVideoModal = () => {
    this.setState({videoHindiModal:true});
    this.setState({videoHindiModalState:true});
    console.log(this.state);
  }

  closeVideoModal = () => {
    this.setState({videoModal:false});
    // this.setState({videoModalState:false});
  }

  closeHindiVideoModal = () => {
    this.setState({videoHindiModal:false});
    // this.setState({videoModalState:false});
  }

  restartQue = () => {
    this.setState({restart:false,secondCount1:0});
  }

  changeInput = (e) => {
    let { name, value } = e.target;
    var bodyFormData = new FormData();
    bodyFormData.set('question_id', this.state.questionData[this.state.currentQuestion].id);
    bodyFormData.set('tag', value);
  
    bodyFormData.set('id', this.state.type);
    bodyFormData.set('prediction', this.state.prediction);
    bodyFormData.set('type', this.state.aType);
    bodyFormData.set('mark', this.state.mark);
      API({
          method: 'POST',
          url: 'set/tag',
          data:bodyFormData
        }).then(data => {
          let items = this.state.questionData;

          //var foundIndex = items.findIndex(x => x.id == item.id);
          items[this.state.currentQuestion] = {...this.state.questionData[this.state.currentQuestion],tag:[{tag:value}]};
          this.setState({'questionData':items});
          //this.setState({'questionData':data.data.result.data});
            //this.loadQuestiondata();
            //store.dispatch(setAlert({'flag':true,'type':1,'message':data.data.message}));
            //this.setState({testModal:false, testCount:data.data.count});
      });
    this.setState({ [name] : value });
  };

  soundChecked = () => {}
  stopRecording = () => {}


  render() {
    let que;
    let ques_title = "";
    let title;
    let topBar = false;
    let props = { 
      restart:this.state.restart,
      restartQue:this.restartQue,
      submit:this.submitResponse,
      showResult:this.resultStatus,
      data:this.state.questionData[this.state.currentQuestion],
      func:this.changeAnswer,
      answer:this.state.is_answer,
      resultMode:false,
      testCount:0,
      tag:'grey',
      testMode:false,
      resultId:false,
      soundChecked:this.soundChecked,
      stopRecording:this.state.stopRecording
    }; 
    if (this.state.questionData.length >0) {
      ques_title = this.state.questionData[this.state.currentQuestion].q_title;
    }
    switch(this.state.type) {
      case "1":
        que = <ReadAloud {...props} />;
        title = "Look at the text below. In the 35 seconds, you must read this text aloud as naturally and clearly as possible. You have 35 seconds to read aloud.";
        break;
      case "2":
        que = <RepeatSentece {...props} />;
        title = "You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.";
        break;
      case "3":
        que = <DescribeImage {...props} />;
        title = "Look at the Image below. In 25 seconds,please speak into the microphone and describe in detail what the graph showing. You will have 40 seconds to give your response.";
        break;
      case "4":
        que = <RetellLec {...props} />;
        title = "You will hear a lecture. After listening to the lecture, in 10 seconds, please speak into the microphone and retell what you have just heard from the lecture in your own words. You will have 40 seconds to give your response.";
        break;
      case "5":
        que = <ShortQue {...props} />;
        title = "You will hear a question. Please give a simple and short answer. Often just one or a few words is enough.";
        break;
      case "6":
        que = <Summary {...props} />;
        title = "Read the passage and summarize it using one sentence. Type your response in the box at the bottom of the screen. You have 10 minutes to finish this task. your response will be judge on the quality of your writing and on how well your response presents the key points in the passage.";
        break;
      case "7":
        que = <Essay {...props} />;
        title = "You will have 20 minutes to plan, write and revise an essay about the topic below. your response will be judged on how well you develop a position, oraganize your ideas, present supporting details, and control the elements of standard written English. You should write 200-300 words.";
        break;
      case "8":
        topBar = true;
        que = <SingleAnswer {...props} />;
        title = "Read the text and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
        break;
      case "9":
        topBar = true;
        que = <MultipleAnswer {...props} />;
        title = "Read the text and answer the question by selecting all the correct responses. More than one response is correct.";
        break;
      case "10":
        que = <Reorder {...props} />;
        title = "The textbox in the left panel have been placed in a random order. Restore the original order by dragging the text boxes from the left panel to the right panel.";
        break;
      case "11":
        topBar = true;
        que = <ReadingBlank {...props} />;
        title = "In the text below some words are missing. Drag words from the text box below to the appropriate place in the text. To undo an answer choice, drag the word back to the box below the text.";
        break;
      case "12":
        topBar = true;
        que = <WrittingBlank {...props} />;
        title = "Below is a text with blanks. Click on each blank, a list of choices will appear. Select the appropriate answer choice for each blank.";
        break;
      case "13":
        que = <Summer {...props} />;
        title = "You will hear a short lecture. Write a summary for a fellow student who was not present at the lecture. You should wirte 50-70 words. You have 10 minutes to finish the task. Your response will be judged on the quality of your writing and on how well your response presents the key points presented in the lecture.";
        break;
      case "14":
        topBar = true;
        que = <McqSingle {...props} />;
        title = "Listen to the recording and answer the multiple-choice question by selecting the correct response. Only one response is correct.";
        break;
      case "15":
        topBar = true;
        que = <McqMulti {...props} />;
        title = "Listen to the recording and answer the question by selecting all the correct responses. You will need to select more than one response.";
        break;
      case "16":
        topBar = true;
        que = <ListeningBlank {...props} />;
        title = "You will hear a recording. Type the missing words in each blank.";
        break;
      case "17":
        topBar = true;
        que = <CorrectSummary {...props} />;
        title = "You will hear a recording. Click on the paragraph that best relates to the recording.";
        break;
      case "18":
        topBar = true;
        que = <MissingWord {...props} />;
        title = "You will hear a recording about "+ ques_title+". At the end of the recording the last word or group of words has benn replaced by a beep. Select the correct option to complete the recording";
        break;
      case "19":
        topBar = true;
        que = <Highlight {...props} />;
        title = "You will hear a recording. Below is a transcription of the recording. Some words in the transcription differ from what the speaker(s) said. Please click on the words that are different.";
        break;
      case "20":
        que = <Dictation {...props} />;
        title = "You will hear a sentence. Type the sentence in the box below exactly as you hear it. Write as much of the sentence as you can. You will hear the sentence only once.";
        break;
      default:
        // code block
    }
    return (
      <>
      <Helmet htmlAttributes>
        <title>Top PTE Training Institute</title>
        </Helmet>
        {!this.state.all_ok && <ChromeCheck />}
        {this.state.all_ok && <div className="content questionsArea">
                {this.state.modal && <Modal isOpen={this.state.modal} size="lg">
                    <ModalBody>
                    
                    <ModalHeader>Report the problem in this question </ModalHeader>
                      <Input type="textarea" value={this.state.reportText} name="reportText" onChange={(e)=>{this.changeReportText(e);}} />
                    </ModalBody>
                    <ModalFooter>
                      <Button color="secondary" className="modalCloseBtn" onClick={this.submitReport}>Submit</Button>
                      <Button color="secondary" className="modalCloseBtn" onClick={this.showModal}>Close</Button>
                    </ModalFooter>
                  </Modal>}
        
                  {<Modal isOpen={this.state.testModal} size="lg">          
                    <ModalHeader>Do you have seen this question in exam </ModalHeader>                        
                    <ModalFooter>
                      <Button color="secondary" className="modalCloseBtn" onClick={this.testedYes}>Yes</Button>
                      <Button color="secondary" className="modalCloseBtn" onClick={this.testedNo}>No</Button>
                    </ModalFooter>
                  </Modal>}

                  {this.state.videoModal && <Modal className="videopopup" centered="true" isOpen={this.state.videoModalState} size="lg">
                    <ModalBody>
                      <ReactPlayer url={this.state.videoUrl} controls={true}/>
                    </ModalBody>
                    <ModalFooter>
                      <Button color="secondary" className="modalCloseBtn" onClick={this.closeVideoModal}>Close</Button>
                    </ModalFooter>
                  </Modal>}

                  {this.state.videoHindiModal && <Modal className="videopopup" centered="true" isOpen={this.state.videoHindiModalState} size="lg">
                    <ModalBody>
                      <ReactPlayer url={this.state.videoHindiUrl} controls={true}/>
                    </ModalBody>
                    <ModalFooter>
                      <Button color="secondary" className="modalCloseBtn" onClick={this.closeHindiVideoModal}>Close</Button>
                    </ModalFooter>
                  </Modal>}

                  <Row>
                  
                    <Col xs={12}>
        
                      <Card>
                        {this.state.process && <div class="scoreLoader text-center showLoader">
                          <span>AI Scoring Ongoing ...</span>
                        </div>}
                        <CardHeader>
                        {topBar && this.state.is_answer && <div class="row infoBars">
                            <div class="col-sm-3 wrongAns">
                              <i class="fa fa-times" aria-hidden="true"></i> <span>Your selected & wrong answer</span>
                            </div>
                            <div class="col-sm-3 correctAns">
                              <i class="fa fa-check" aria-hidden="true"></i> <span>Your selected & correct answer</span>
                            </div>
                            <div class="col-sm-3 notSelected">
                              <i class="fa fa-check" aria-hidden="true"></i> <span>Not selected & correct answer</span>
                            </div>
                          </div>}
                          <Row>
                          <Col xs={6}>
                              <CardTitle tag="h3">
                              {this.state.questionData.length > 0 && this.state.questionData[this.state.currentQuestion].q_title}
                               {this.state.questionData.length > 0 && <select name="tag" onChange={(e) => { this.changeInput(e)} } style={{border:'0px',fontFamily: 'FontAwesome',background: 'white',color:this.state.tag}}>
                                                         <option value="grey" style={{color:'grey'}}>&#xf02c;</option>
                                                         <option value="red" style={{color:'red'}}>&#xf02c;</option>
                                                         <option value="green" style={{color:'green'}}>&#xf02c;</option>
                                                         <option value="yellow" style={{color:'yellow'}}>&#xf02c;</option>
                                                       </select> }
                              </CardTitle>
                              {this.state.questionData.length > 0 && this.state.questionData[this.state.currentQuestion].is_weekly_prediction === 1 && <Badge color="primary">Weekly Prediction</Badge>}
                              {this.state.questionData.length > 0 && this.state.questionData[this.state.currentQuestion].is_exam_question === 1 && <Badge color="primary">Exam Question</Badge>}
                              {this.state.questionData.length > 0 && this.state.questionData[this.state.currentQuestion].complexity === 0 && <Badge color="primary">Easy</Badge>}
                              {this.state.questionData.length > 0 && this.state.questionData[this.state.currentQuestion].complexity === 1 && <Badge color="primary">Medium</Badge>}
                              {this.state.questionData.length > 0 && this.state.questionData[this.state.currentQuestion].complexity === 2 && <Badge color="primary">Difficult</Badge>}
                              {this.state.isAttempted && <Badge color="success">Attempted</Badge>}
                              
                            </Col>

                          <Col xs={6}>

        
                          
        
                              <div className="text-right questionTime">
                                <div className="timeRemaining">
                                  {<p><b><i class="fa fa-clock-o"></i> <span>Time spent: {Math.floor(this.state.secondCount1 / 60) +':'+ (this.state.secondCount1 % 60)}</span></b></p>}
                                </div>
                                <div className="item">
                                  {!this.state.hideNav && <p>Item {this.state.currentQuestion+1} of {this.state.questionData.length}</p>}
                                </div>
                              </div>
                            </Col>
                            
                            
                          </Row>
                          {title}
                        </CardHeader>
                        <CardBody>
                        {this.state.questionData.length ===0 && <h5 class="text-center">No Question Found</h5>}
        
                          <Row className='unselectable'>
                          {!this.state.isBlocked && this.state.questionData.length !==0 && store.getState().loaded && this.state.questionData && que }
                          {this.state.isBlocked && <h2>Please attach microphone to your system </h2>}
                          {this.state.is_answer && this.state.resultData !== '' && <Col xs={12}><div className="result-div">{ this.state.resultData.split('\n').map((item, i) => {
                              return <h4>{ReactHtmlParser(item)}</h4>;
                          }) }
                          {(this.state.type === '3' || this.state.type === '4')  && <div>
                              <div class="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW" >
                              <div class="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                <div class="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd" ></div>Good</div>
                                <div class="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                <div class="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJav">
                                </div>Average</div>

                                </div>
                            </div>}
                          {(this.state.type === '1' || this.state.type === '2')  && <div>
                              <div class="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW" >
                              <div class="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                <div class="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd" ></div>Good</div>
                                <div class="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                                <div class="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJbad"></div>Bad pronunciation/Missed words</div><div class="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca"></div></div>
                            </div>}
                          {/*<ShowHistory data={this.state.history} flag={1} id={this.state.resultId} />*/}
                          <ShowHistoryData data={this.state.historyData} flag={1} id={this.state.resultId} />
                          {this.state.type === '5' && <h3>Correct Answer - <span className="green-text">{this.state.questionData[this.state.currentQuestion].answer}</span></h3> }
                          </div></Col> }
                          </Row>
                          {this.state.switched && <span className="unselectable">
                          <h3>Question Audio</h3>
                            <audio src={base + this.state.questionData[this.state.currentQuestion].media_link} controls="controls" />
              
                          <h3>Audio Script</h3>
                          <div className="audio_script_text">{this.state.questionData[this.state.currentQuestion].audio_script}
                          </div></span>}
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xs={12}>
                    {false && !this.state.isSubscribed && <span className="badge badge-primary">(A.I. Token(s) X {this.state.user.a_token})</span>}
                    {!this.state.isBlocked && this.state.questionData.length !==0 && <div className="bottomBtns">
                        <div className="row">
                          <Col xs={8}>
                            {false && !this.state.isSubscribed && this.state.user.a_token > 0 && !this.state.process && <Button color="primary" className="bottom-btn" disabled={this.state.is_answer || !this.state.submitFlag} onClick={this.showResponse}  size="sm">Submit</Button>}
                            { !this.state.process && <Button color="primary" className="bottom-btn" disabled={this.state.is_answer || !this.state.submitFlag} onClick={this.showResponse}  size="sm">Submit</Button>}
                            {false && !this.state.isSubscribed && this.state.user.a_token <= 0 && !this.state.process && <Link to="/video-courses"><Button color="primary" className="bottom-btn"   size="sm">Subscribe to paid plan for submit answer</Button></Link>}
                            {this.state.process && <Button color="primary" className="bottom-btn"  size="sm"><i className="fa fa-spinner"></i>&nbsp;Submit</Button>}
                            {<Button color="info" className="bottom-btn" onClick={this.restartQuestion} disabled={false} size="sm">Restart</Button>}
                            {this.state.viewVideo ? <Button color="info" className="bottom-btn" onClick={this.showVideoModal} disabled={false} size="sm">Explanation (English)</Button>:''}
                            {this.state.viewHindiVideo ? <Button color="info" className="bottom-btn" onClick={this.showHindiVideoModal} disabled={false} size="sm">Explanation (Hindi)</Button>:''}
                            {[4,2,5,13,14,15,16,17,18,19,20].includes(this.state.questionData[this.state.currentQuestion].subcategory_id) && <span className="audio_script_button">Audio Transcript : <Switch onText="Show" offText="Hide" onChange={(el, state) => this.toggleSwitch(el, state)} on={this.state.switched}></Switch></span>}
                            
                          </Col>
                          {!this.state.hideNav && <Col xs={4} className="text-right">
                                                      <select className="selectPage" onChange={this.changeSelectPagination} >
                                                        {Array.from({ length: this.state.questionData.length }, (value, key) => <option value={key} >{key+1}</option>)}
                                                        
                                                      </select>
                                                      { this.state.questionData.length !== 0 && <Button color="info" className="bottom-btn" onClick={this.prevButton} disabled={ (this.state.currentQuestion === 0 ) } size="sm">Previous</Button>}
                                                      { this.state.questionData.length !== 0 && <Button color="info" className="bottom-btn" onClick={this.nextButton} disabled={((this.state.questionData.length-1)===this.state.currentQuestion ) } size="sm">Next</Button>}
                                                    </Col>}
                          {this.state.hideNav && <Col xs={4}></Col>}
                        </div>
                      </div>}
                    </Col>
                    <Col xs={12}>
                      <div>
                        <>
                        <div>
                        <>
                          <div className="bottomBtns">
                            {this.state.questionData.length !==0 && <Button color="info" className="bottom-btn" size="sm">{this.state.questionData[this.state.currentQuestion].attempted.length} x Attempted</Button>}
                            {this.state.questionData.length !==0 && <Button color="info" onClick={this.testedFunc} className="bottom-btn" size="sm">{this.state.testCount} x tested</Button>}
                            {this.state.questionData.length !== 0 && <Button color="info" style={{float:'right'}} className="bottom-btn" onClick={this.showModal} disabled={false} size="sm">Report</Button>}
                          </div>
                      </>
                        <Row className="discussion row">
                              <div className="discuTabs">
                                <ul class="nav nav-tabs">
                                  <li class={this.state.comment_flag && "active"}>
                                    {this.state.questionData.length !== 0  && <a href  onClick={this.showComment}><i class="fa fa-commenting-o" aria-hidden="true"></i> &nbsp;Discussion</a>}
                                  </li>
                                  <li class={this.state.history_flag && "active"}>
                                    {this.state.questionData.length !== 0 && <a href onClick={this.showHistory}><i class="fa fa-list-ul" aria-hidden="true"></i> &nbsp;Me</a>}
                                  </li>
                                  <li class={this.state.board_flag && "active"}>
                                    {this.state.questionData.length !== 0 && <a href onClick={this.showBoard}><i class="fa fa-list-ul" aria-hidden="true"></i> &nbsp;Others</a>}                                    
                                  </li>
                                  <li class={this.state.note_flag && "active"}>
                                    {this.state.questionData.length !== 0  && <a href  onClick={this.showNotes}><i class="fa fa-pencil" aria-hidden="true"></i> &nbsp;Notes</a>}
                                  </li>
                                </ul>
                              </div>
                          
                          </Row>
                    </div>
                          
                        </>
                      </div>
                    </Col>
                    <Col xs={12} className="practiceContent">
                      
                          <div>
                            {this.state.note_flag && <UserNotes question={this.state.questionData[this.state.currentQuestion].id} />}
                            {this.state.history_flag && <ShowHistory all="0" changeResponseArr={this.changeResponseArr} question={this.state.questionData[this.state.currentQuestion].id} flag={0} />}
                            {this.state.board_flag && <ShowHistory all="1" changeResponseArr={this.changeResponseArr} question={this.state.questionData[this.state.currentQuestion].id} flag={0} />}
                            {this.state.comment_flag && <QuestionComment question={this.state.questionData[this.state.currentQuestion].id} />}
                          </div>
                          
                       
                    </Col>
                  </Row>
                </div>}
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Practice);
